function getAnchor() {
	return (document.URL.split('#').length > 1) ? document.URL.split('#')[1] : null;
}
const anchor = getAnchor();
if (!anchor) {

	document.documentElement.style.setProperty('--animated-component-opacity', '0');
	const animationElements = [];

	function isElementInViewport(element) {
		const rect = element.getBoundingClientRect();
		return (
			rect.top <= (window.innerHeight || document.documentElement.clientHeight) &&
			rect.bottom >= 0
		);
	}
	function updateAnimationsElementsInViewport() {
		for (const animationElement of animationElements) {
			const isInViewport = isElementInViewport(animationElement);
			if (isInViewport) {
				animationElement.setAttribute('data-in-view', 'true');
				const index = animationElements.indexOf(animationElement);
				if (index > -1) {
					animationElements.splice(index, 1);
				}
			}
		}
	}
	window.updateAnimationsElementsInViewport = updateAnimationsElementsInViewport; // make available for other scripts to use
	addEventListener('DOMContentLoaded', updateAnimationsElementsInViewport, false);
	addEventListener('load', updateAnimationsElementsInViewport, false);
	addEventListener('scroll', updateAnimationsElementsInViewport, false);
	addEventListener('resize', updateAnimationsElementsInViewport, false);


	const target = document.querySelector('html');

	const observer = new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			const foundAnimationElements = document.querySelectorAll('[data-es-animation]');
			for (const foundAnimationElement of foundAnimationElements) {
				if (!animationElements.includes(foundAnimationElement) && foundAnimationElement.getAttribute('data-in-view') !== 'true') {
					foundAnimationElement.setAttribute('data-in-view', 'false');
					animationElements.push(foundAnimationElement);
				}
			}
			updateAnimationsElementsInViewport();
		});
	});

	const config = {
		childList: true,
		subtree: true,
	}

	observer.observe(target, config);

}
